var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFinetuneParametersLipSync = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12 9.267c-2.5-3.128-4 .52-7 .52C5 9.788 7.5 15 12 15s7-5.212 7-5.212c-3 0-4.5-3.649-7-.521m0 3.235c-2.222 0-4-1.852-4-1.852s1.778.463 4 .463 4-.463 4-.463-1.778 1.852-4 1.852"
})));
export default SvgFinetuneParametersLipSync;